const MAMBA_EXEMPT_TENANT_NAME = 'mamba solutions llc';

export const normalizeTenantName = (name?: string | null): string =>
  (name || '')
    .trim()
    .toLowerCase()
    .replace(/[^\w\s]/g, '')
    .split(/\s+/)
    .filter(Boolean)
    .join(' ');

export const isMambaExemptTenantName = (name?: string | null): boolean =>
  normalizeTenantName(name) === MAMBA_EXEMPT_TENANT_NAME;
